import { TicketDetailsModel, UpdateTicketPayload } from "@jugl-web/rest-api";
import { TicketListItemModel } from "@jugl-web/rest-api/tickets/models/TicketListItem";
import { TableGrid } from "@jugl-web/ui-components";
import { WithOptimistic } from "@jugl-web/utils";
import { FC, useCallback } from "react";
import { useClientSupportPageContext } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { useTicketsViewTableColumns } from "./hooks/useTicketsViewTableColumns";

interface TicketsViewTableProps {
  entityId: string;
  tickets: WithOptimistic<TicketListItemModel>[];
  produceUpdateTicketFn: (
    ticketId: string
  ) => (data: UpdateTicketPayload) => Promise<TicketDetailsModel | undefined>;
}

export const TicketsViewTable: FC<TicketsViewTableProps> = ({
  entityId,
  tickets,
  produceUpdateTicketFn,
}) => {
  const { ticketDetailsSidebarState } = useClientSupportPageContext();

  const columns = useTicketsViewTableColumns({
    entityId,
    produceUpdateTicketFn,
  });

  const isItemActive = useCallback(
    (item: TicketListItemModel) =>
      ticketDetailsSidebarState.isOpen &&
      item.id === ticketDetailsSidebarState.ticketId,
    [ticketDetailsSidebarState]
  );

  return (
    <TableGrid
      id="client-support-tickets-view"
      variant="grid"
      noCellPadding
      classNames={{
        wrapper:
          "w-fit min-w-full overflow-visible border-t-0 border-l-0 border-r-0 rounded-none",
        bodyCell: "rounded-none!",
      }}
      columns={columns}
      data={tickets}
      isItemActive={isItemActive}
    />
  );
};
